export const dataWorkingProcess = {
  subTitle: "NOTRE processus de travail",
  title: "Comment fonctionnent nos services",
  items: [
    {
      id: 1,
      img: "assets/images/services/services-round-1.png",
      title: "Rencontre avec le client",
      desc: 'Comprendre en détail les besoins et attentes du client pour garantir sa satisfaction totale, conformément à notre principe fondamental où "le client est ROI".',
    },
    {
      id: 2,
      img: "assets/images/services/services-round-2.png",
      title: "Stratégie du projet",
      desc: "Définir l'approche et le plan d'action du projet en intégrant nos valeurs fondamentales : assurer une qualité optimale, proposer un juste prix et garantir le respect rigoureux des délais impartis.",
    },
    {
      id: 3,
      img: "assets/images/services/services-round-3.png",
      title: "Réalisation du projet",
      desc: "Mettre en œuvre le projet par nos équipes d'ingénieurs et techniciens expérimentés, en appliquant notre démarche qualité rigoureuse (conforme aux normes ISO 9001, 14001 et 45001) pour assurer le respect des standards internationaux de qualité, de sécurité et d'environnement.",
    },
  ],
};
